import { ApiClient } from '@/shared/api-client';
import { ILogAggregationCollection } from '@/shared/api-client/clients/log-client';
import { IMetric } from '@/shared/api-client/models';
import { Formatter } from '@/shared/helpers';
import { Component, Prop, Vue } from 'vue-property-decorator';

interface IInterval {
    from: string;
    to: string;
}

@Component
export default class MetricsComponent extends Vue {

    @Prop() public organizationalPaths!: string[];

    @Prop() public trackingStarted!: string;

    @Prop({ default: 'sv-SE' }) public language!: string;

    @Prop({ default: 'Standalone' }) public context?: string;

    @Prop() public translations!: { [key: string]: string; };

    public aggregationCollections: ILogAggregationCollection[] = new Array<ILogAggregationCollection>();

    public interval: IInterval = {
        from: '',
        to: '',
    }

    public xhrError = false;
    public show = false;
    public loading = true;

    private apiClient: ApiClient = new ApiClient();

    /**
     * Life cycle hook for when component is created
     */
    public async created() {

        const year = new Date().getUTCFullYear();
        const month = new Date().getUTCMonth();
        const day = new Date().getUTCDate();

        this.interval.from = `${year}-01-01`;
        this.interval.to = `${year}-${(month + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;

        if (this.context === 'Modal') {

            await this.load();
        }
    }

    private async load(): Promise<void> {

        const promises = new Array<Promise<ILogAggregationCollection>>();

        this.organizationalPaths.forEach(path => {

            promises.push(this.apiClient.log.aggregate(
                path,
                this.interval.from
                    ? new Date(new Date(this.interval.from).setUTCHours(0, 0, 0, 0))
                    : undefined,
                this.interval.to
                    ? new Date(new Date(this.interval.to).setUTCHours(23, 59, 59, 999))
                    : undefined
            ));
        });

        try {

            const all = await Promise.all(promises);

            this.aggregationCollections = new Array<ILogAggregationCollection>();

            all.forEach(promise => {
                this.aggregationCollections.push(promise);
            });

            this.aggregationCollections.sort((a, b) => a.header.localeCompare(b.header)); // https://caniuse.com/localecompare

        }
        catch (error) {

            this.xhrError = true;
        }
        finally {

            this.loading = false;
        }
    }

    public getCount(collections: IMetric[], aggregationName: string): string {

        const match = collections?.find(a => a.name === aggregationName);

        if (match) {

            return Formatter.number(match.count, this.language);
        }

        return '0';
    }

    public async toggleMetrics($event: MouseEvent) {

        if (this.show) {

            this.show = false;

        } else {

            this.show = true;

            await this.load();
        }
    }

    public async intervalChange($event: MouseEvent) {

        await this.load();
    }
}

